import instance from "./axios.config";

const getAdminuserslist = () =>
    instance.get(`/admin/globaluserlist`);

const getAdminshiplist = () =>
    instance.get(`/admin/globalshiplist`);

const getallOwners = () =>
    instance.get(`/admin/getallowner`);

const getOwnerDetailById = (ower_id) =>
    instance.get(`/admin/getownerdetail/${ower_id}`);



//SUBSCRIPTIONS
const allsubscription = () => instance.get(`/subscribe`);
const createsubscription = (payload) => instance.post(`/subscribe`, payload);
const updateSubscription = (id, payload) => instance.put(`/subscribe/${id}`, payload);
const deleteSubscription = (id) => instance.delete(`/subscribe/${id}`);
const syncSubscription = (name) => instance.get(`/owner/update/${name}`);
const synclocalSubscription = (payload) => instance.put(`/owner/update`, payload);



//Report
const allreports = () => instance.get(`/reports`);
const createReport = (payload) => instance.post(`/reports`, payload);
const updateReport = (id, payload) => instance.put(`/reports/${id}`, payload);
const deleteReport = (id) => instance.delete(`/reports/${id}`);



const adminService = {
    allreports, createReport, updateReport, deleteReport, synclocalSubscription,
    allsubscription, createsubscription, updateSubscription, deleteSubscription,
    getAdminuserslist, getAdminshiplist, getOwnerDetailById, getallOwners, syncSubscription
}
export default adminService;
